import { render, staticRenderFns } from "./ListCapituloView.vue?vue&type=template&id=72f289aa&scoped=true"
import script from "./ListCapituloView.vue?vue&type=script&lang=js"
export * from "./ListCapituloView.vue?vue&type=script&lang=js"
import style0 from "./ListCapituloView.vue?vue&type=style&index=0&id=72f289aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f289aa",
  null
  
)

export default component.exports